import React from 'react';
import { useNavigate } from 'react-router-dom';
import { soundManager } from '../utils/SoundManager';
import historyFiveTrainersData from '../data/HistoryFive';
import './HistoryFive.css';

const HistoryFiveTrainers = () => {
    const navigate = useNavigate();

    // Convert trainer data object to array
    const trainers = Object.values(historyFiveTrainersData);

    // Handle trainer selection
    const handleTrainerSelect = (trainer) => {
        console.log('📚 Literary Giant/Cultural Legend selected:', trainer.name);

        // 🎵 TRAINER SELECTION SOUND
        soundManager.playButtonSound();

        // Navigate to individual trainer page
        navigate(`/history-trainer/${trainer.id}`);
    };

    // Handle back navigation
    const handleBackToCategories = () => {
        soundManager.playButtonSound();
        navigate('/history-train-categories');
    };

    return (
        <div className="history-trainers-container">
            <div className="history-animated-background muse-flow"></div>

            {/* Back Button */}
            <button
                className="back-to-categories-button"
                onClick={handleBackToCategories}
            >
                ← Back to Categories
            </button>

            {/* Header */}
            <div className="history-trainers-header">
                <div className="header-content">
                    <h1>Literary Giants & Cultural Legends</h1>
                    <p>Train with legendary writers, artists, musicians, and cultural icons</p>
                    <div className="category-stats">
                        <span className="stat-badge">Trainers: {trainers.length}</span>
                        <span className="stat-badge">Programs: {trainers.length * 6}</span>
                        <span className="stat-badge">Category: Literature & Culture</span>
                    </div>
                </div>
            </div>

            {/* Trainers Grid */}
            <div className="history-trainers-grid">
                {trainers.map((trainer, index) => (
                    <div
                        key={trainer.id}
                        className="history-trainer-card floating-literary-element inspiration-quill wisdom-pulse"
                        onClick={() => handleTrainerSelect(trainer)}
                        data-character={trainer.id}
                        style={{
                            '--history-primary-color': trainer.color,
                            '--history-secondary-color': trainer.secondaryColor
                        }}
                    >
                        {/* Character-specific accent icons */}
                        {trainer.id === 'edgar-allan-poe' && <div className="quill-accent"></div>}
                        {trainer.id === 'oscar-wilde' && <div className="book-accent"></div>}
                        {trainer.id === 'wolfgang-amadeus-mozart' && <div className="music-accent"></div>}
                        {trainer.id === 'vincent-van-gogh' && <div className="palette-brush-accent"></div>}
                        {trainer.id === 'blackbeard' && <div className="ship-pirate-accent"></div>}
                        {trainer.id === 'p-t-barnum' && <div className="circus-accent"></div>}

                        {/* Trainer Image */}
                        <div className="history-trainer-image-section">
                            <div
                                className="history-trainer-image"
                                style={{
                                    backgroundImage: `url(${trainer.image})`
                                }}
                            >
                                <div className="literary-aura-effect"></div>
                                <div className="experience-badge history-badge">
                                    {trainer.experience}
                                </div>
                            </div>
                        </div>

                        {/* Trainer Info */}
                        <div className="history-trainer-info-section parchment-texture">
                            <h3 className="history-trainer-name">{trainer.name}</h3>
                            <p className="history-trainer-specialization">{trainer.specialization}</p>
                            <p className="history-trainer-description">{trainer.intro}</p>

                            <div className="history-trainer-details">
                                <div className="detail-item history-detail">
                                    <div className="detail-icon">📖</div>
                                    <div className="detail-text">Programs: {trainer.programs.length}</div>
                                </div>
                                <div className="detail-item history-detail">
                                    <div className="detail-icon">🎭</div>
                                    <div className="detail-text">{trainer.experience}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Literary Divider */}
            <div className="literary-divider"></div>

            {/* Footer */}
            <div className="history-trainers-footer manuscript-pattern">
                <div className="history-info">
                    <h3>Literary Giants & Cultural Legends Philosophy</h3>
                    <div className="history-benefits-grid">
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🖤</div>
                            <div>
                                <strong>Gothic Dark Beauty Training</strong>
                                <p>Psychological conditioning that transforms personal torment into eternal artistic beauty through Gothic mastery</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">✨</div>
                            <div>
                                <strong>Aesthetic Philosophy Elegance</strong>
                                <p>Art for art's sake conditioning that builds wit into physical grace and transforms scandal into immortal beauty</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🎼</div>
                            <div>
                                <strong>Musical Prodigy Divine Power</strong>
                                <p>Child genius training that channels heaven's music through supernatural ability and transcendent composition</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🌟</div>
                            <div>
                                <strong>Cosmic Vision Passionate Art</strong>
                                <p>Tortured genius conditioning that swirls universal energy into passionate expression and transcendent beauty</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🏴‍☠️</div>
                            <div>
                                <strong>Pirate Terror Maritime Power</strong>
                                <p>Psychological warfare training that creates supernatural dread through burning beards and Atlantic domination</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🎪</div>
                            <div>
                                <strong>Spectacular Entertainment Genius</strong>
                                <p>Master showmanship conditioning that turns ordinary acts into extraordinary sensations and creates impossible dreams</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HistoryFiveTrainers;